import { DataTable } from '@/components/common/DataTable';
import { ISnowfallItem } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { formatFullMonth } from '@/util/formatAgo';
import { SnowUnit } from '@/components/blocks/Unit';
import { Heading } from '@/components/ui/heading';

// Monthly snowfall table for a single resort. Columns: month label /
// total snowfall / snow days / avg base depth / max base depth (md+) /
// biggest snowfall (md+). One row per month in the resort's history.

export const Monthly = ({
  infoMonthly,
  resortName,
}: {
  infoMonthly: Array<ISnowfallItem>;
  resortName: string;
}) => {
  const { t } = useOTSTranslation('common');

  return (
    <section className="mb-10">
      <Heading
        level={2}
        className="mb-4"
      >
        {t('resort.historicalSnowfall.monthTabTitle' as never, { resort: resortName })}
      </Heading>
      <DataTable minWidth={520}>
        <DataTable.Head>
          <DataTable.HeadRow>
            <DataTable.HeadCell />
            <DataTable.HeadCell align="right">
              {t('resort.historicalSnowfall.totalSnowfall')}
            </DataTable.HeadCell>
            <DataTable.HeadCell align="right">
              {t('resort.historicalSnowfall.snowfallDay')}
            </DataTable.HeadCell>
            <DataTable.HeadCell align="right">
              {t('resort.historicalSnowfall.avgBaseDepth')}
            </DataTable.HeadCell>
            <DataTable.HeadCell align="right" className="hidden md:table-cell">
              {t('resort.historicalSnowfall.maxBaseDepth')}
            </DataTable.HeadCell>
            <DataTable.HeadCell align="right" className="hidden md:table-cell">
              {t('resort.historicalSnowfall.biggestSnowfall')}
            </DataTable.HeadCell>
          </DataTable.HeadRow>
        </DataTable.Head>
        <DataTable.Body>
          {infoMonthly.map((item, i) => {
            const pluralDays = item.snowDays !== 1;
            return (
              <DataTable.Row key={item.date} zebra={i % 2 === 0}>
                <DataTable.RowHeader>
                  {formatFullMonth(item.date)}
                </DataTable.RowHeader>
                <DataTable.Cell align="right">
                  <SnowUnit values={item.totalSnow} />
                </DataTable.Cell>
                <DataTable.Cell align="right">
                  {t(pluralDays ? 'common.timeDay_plural' : 'common.timeDay', {
                    count: item.snowDays,
                  })}
                </DataTable.Cell>
                <DataTable.Cell align="right">
                  <SnowUnit values={item.baseDepth} />
                </DataTable.Cell>
                <DataTable.Cell align="right" className="hidden md:table-cell">
                  <SnowUnit values={item.maxBaseDepth} />
                </DataTable.Cell>
                <DataTable.Cell align="right" className="hidden md:table-cell">
                  <SnowUnit values={item.biggestSnowfall} />
                </DataTable.Cell>
              </DataTable.Row>
            );
          })}
        </DataTable.Body>
      </DataTable>
    </section>
  );
};
